import { FormattedMessage } from 'react-intl'
import groupBy from 'lodash/groupBy'
import {
  getTextFromInfo,
  getOccupancyInRoomString,
} from '../../../../../utils'

const BookingDetailsCardRoomsInfo = ({ order }) => {
  const {
    rooms,
    orderDetails: { accomodation },
  } = order

  const roomsOccupied = Object.values(accomodation).map((item) => {
    item.occupancy = item.divers + item.nonDivers + item.students
    return item
  })
  const groupedRooms = groupBy(roomsOccupied, 'occupancy')
  return (
    <ul className='options'>
      <li>
        <i className='font-icons room-icon' />
        {rooms.quantity > 1 ? rooms.quantity + ' x ' : ' '}
        {rooms.title}
        {rooms.minAge && (
          <small>
            <FormattedMessage
              id='profile.booking.min_age'
              defaultMessage='(min age: { minAge })'
              values={{ minAge: rooms.minAge }}
            />
          </small>
        )}
      </li>
      <li>
        {Object.keys(groupedRooms).map((key, index) => (
          <p key={key}>
            <i
              className={`font-icons peoples-icon ${
                index !== 0 ? 'invisible' : ''
              }`}
            />
            <span>
              {getOccupancyInRoomString(key, groupedRooms[key].length)}
            </span>
            {/* listing number of rooms that match this occupancy */}
            {groupedRooms[key].map((room, index, arr) => (
              <span key={index}>
                {room.title ? room.title + ' ' : ''}
                {room.index}
                {index !== arr.length - 1 ? ', ' : ' '}
              </span>
            ))}
          </p>
        ))}
      </li>
      <li>
        <i className='font-icons icon-breakfast' />
        {getTextFromInfo(rooms.mealPlan, 'shop', 'RESORT_MEAL_PLANS')}
      </li>
    </ul>
  )
}

export default BookingDetailsCardRoomsInfo
